<svelte:options tag="and-step-progress-indicator"></svelte:options> 
<style style type="text/scss" lang="scss" >
@import "../../../../global.scss";

.progressbar {
  padding-inline-start: 0;
  display: flex;
  justify-content: space-between;

  ::slotted(*) {
    flex-grow: 1;
  }
}

</style>

<script>
import { onMount, tick } from 'svelte';

export let id = 'progress-bar';

let progressbar = '';

let removeLineAfterFirstElement = () => {
  const firstStepItem = progressbar.querySelector('slot').assignedElements()[0];
  const firstLiElem = firstStepItem.shadowRoot.querySelector('li');
  const firstanchorElem = firstLiElem.querySelector('a');
  
  if(firstanchorElem) {
    firstanchorElem.classList.add('rmline');
  }
  else{
    firstLiElem.classList.add('rmline');
  }
}

onMount( async() => {
  await tick()
  if(progressbar.querySelector('slot')){
    removeLineAfterFirstElement()
  }
});

</script>
<ol id={id} class="progressbar" bind:this={progressbar}>
    <slot>
        <li>placeholder item</li>
    </slot>
</ol>